import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import constant from '../../constant'



export default class SuccessPayment extends Component {
    constructor(props) {
        super(props)
        this.state = {

        }
    }
    render() {
        return (
            <section className='pricing-area padding-top-100px padding-bottom-80px'>
                <div className="container">
                    <div className='row'>
                        <div className='col-md-12 mt-3'>
                            <div className='success-payment'>
                                <div className='success-img'>
                                    <img src={'./assets/images/success-img.jpg'} />
                                </div>
                                <div className='success-head'>
                                Your Job Posting Payment Is Successful.
                                </div>
                                <div className='success-text'>
                                <p style={{marginBottom: "25px"}}>Thank you for purchasing our <b style={{color:'red'}}>{this.props.packageName}</b> Package. <br/>Your Order ID is <b style={{color:'red'}}> JZSHRE{this.props.Order_Id}</b>.  Start posting your job
                                 openings now and hire the best candidate for your organization. </p>

                                 <p><a href={constant.component.Dashboard.url}><strong>Click here</strong></a> To Start Now.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </section>
        )
    }
}
